import {
  parameterList,
  parameterPayload,
  payloadParameterUpdate
} from 'models/parameters';
import { defaultResponse } from 'models/response';
import { axiosEndPoint } from 'utils/axios';

const path = '/parameters';

export const postNewParameter = async (
  payload: parameterPayload
): Promise<defaultResponse> => {
  const response = await axiosEndPoint.post<defaultResponse>(
    `${path}/new`,
    payload
  );
  return response.data;
};

export const patchParameter = async (
  payload: payloadParameterUpdate
): Promise<defaultResponse> => {
  const response = await axiosEndPoint.patch<defaultResponse>(
    `${path}/`,
    payload
  );
  return response.data;
};

export const getListParameter = async (): Promise<parameterList> => {
  const response = await axiosEndPoint.get<parameterList>(`${path}/list`);
  return response.data;
};
